if (!customElements.get('show-result-button')) {
    class ShowResultButton extends HTMLElement {
        constructor() {
            super();
            this.collectionUrl = this.dataset.collection;
        }

        connectedCallback() {
            const resultButton = this.querySelector('.show-result-button');
            const nextButton = this.querySelector('.go-next-section');
            const prevButton = this.querySelector('.sing-up-prev-button');
            const form = this.closest('form'); // Seleziona il form per il controllo dell'invio

            if (resultButton) {
                resultButton.addEventListener('click', () => this.handleShowResult());
            }

            if (nextButton) {
                nextButton.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.handleNextSection();
                });
            }

            if (prevButton) {
                prevButton.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.handlePrevSection();
                });
            }

            // Aggiungi il listener per l'invio del form e mostra risultati solo in caso di successo
            if (form) {
                form.addEventListener('submit', (event) => {
                    event.preventDefault(); // Previene l'invio tradizionale del form
                    setTimeout(() => {
                        const successMessage = form.querySelector('.newsletter-form__message--success');
                        if (successMessage && successMessage.style.display !== 'none') {
                            this.handleShowResult(); // Mostra i risultati solo se il form ha avuto successo
                        }
                    }, 500); // Ritardo per attendere la risposta di Shopify
                });
            }
        }

        handleShowResult() {
        
            const filters = localStorage.getItem('current_url');
            if (filters) {
                const currentUrl = `${this.collectionUrl}?${filters}`;
                console.log('Redirecting to URL:', currentUrl);
                CookieUtils.setCookie('frame_finder_filter_url', currentUrl, 1);
                window.location.href = currentUrl;
            } else {
                alert("Non ci sono parametri per filtrare.");
            }
        }

        handleNextSection() {
            const currentSection = this.closest('frame-finder-main');
            const currentIndex = parseInt(currentSection.getAttribute('data-index'), 10);
            const nextSection = document.querySelector(`frame-finder-main[data-index="${currentIndex + 1}"]`);

            if (nextSection) {
                currentSection.style.display = 'none';
                currentSection.classList.remove('active');
                nextSection.style.display = 'block';
                nextSection.classList.add('active');
                const nextButtonInSection = nextSection.querySelector('.next-button');
                if (nextButtonInSection) {
                    nextButtonInSection.disabled = false;
                }
            }
        }

        handlePrevSection() {
            const currentSection = this.closest('frame-finder-main');
            const currentIndex = parseInt(currentSection.getAttribute('data-index'), 10);
            const prevSection = document.querySelector(`frame-finder-main[data-index="${currentIndex - 1}"]`);

            if (prevSection) {
                currentSection.style.display = 'none';
                currentSection.classList.remove('active');
                prevSection.style.display = 'block';
                prevSection.classList.add('active');
            }
        }
    }

    customElements.define('show-result-button', ShowResultButton);
}